import React, { ReactFragment } from "react"
import { ReactChild } from "react"
import styled from "styled-components"

interface Props {
  role?: string
  children?: ReactChild | ReactChild[]
  className?: string
}

const Error = styled.div`
  position: absolute;
  bottom: -22px;
  color: #fb4848;
  font-size: 13px;
`

export default function ErrorField(props: Props) {
  const { children, role, className } = props

  return (
    <Error className={className} role={role}>
      {children}
    </Error>
  )
}
